<mat-form-field class="app-input" [floatLabel]="asFormsControl().floatingLabelNever && 'never'">
    <input
        matInput
        #input
        autocomplete="off"

        [ngClass]="{readonly: asFormsControl().readonly, disabled: asFormsControl().disabled}"

        [placeholder]="asFormsControl().placeholder"
        [disabled]="asFormsControl().disabled"
        (focus)="onTouched && onTouched()"
        (keyup)="changeValue($event)"
        (keydown)="toUpperCase($event)"
        (paste)="changeValue($event)"
        [readonly]="asFormsControl().readonly"
    >
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
